.main-footer{
    background-color: $color-bg;
    border-top: 2px solid $primary;
    padding: 120px 0 112px;

    @include max-lg{
        padding: 80px 0;
    }

    &__logo{
        margin-bottom: 80px;

        a{
            display: block;
            width: 210px;

            &:focus-visible{
                outline: 2px solid $moss-green;
                outline-offset: 10px;
            }

            img{
                width: 100%;
                display: block;
            }
        }
    }

    &__links{
        .links{
            display: flex;
            flex-direction: column;
            gap: 16px;

            @include max-md{
                gap: 8px;
            }
        }

        .social{
            margin-top: 80px;
            display: flex;
            flex-direction: row;
            gap: 32px;

            a{
                display: block;

                &:focus-visible{
                    outline: 2px solid $moss-green;
                    outline-offset: 8px;
                }
                
                img{
                    display: block;
                }
            }
        }

        &--right{
            @include max-sm{
                margin-top: 40px;
            }

            .links{
                li{
                    text-align: right;

                    @include max-sm{
                        text-align: left;
                    }
                }
            }
        }

        &--bottom{
            display: flex;
            flex-direction: row;
            align-items: baseline;
            gap: 40px;
            justify-content: space-between;
            margin-top: 80px;

            @include max-lg{
                margin-top: 40px;
            }

            @include max-md{
                flex-direction: column;
            }
            
            .links{
                flex-direction: row;
                flex-wrap: wrap;
                gap: 24px;

                @include max-md{
                    flex-direction: column;
                    gap: 16px;
                }
            }
        }
    }

    &__copyright{
        flex-shrink: 0;
        @extend .body-text;
    }
}